export class SearchParametersEntity {
  filters!: string;
  hitsPerPage!: number;
  page!: number;
  distinct!: number;
  facets!: string[];
  attributesToHighlight!: string[];
  ruleContexts!: string[];
  getRankingInfo!: boolean;
  userToken!: string;
  clickAnalytics!: boolean;
  pageFromRequest!: number;
  indexName?: string;
  params?: string;
}
